import { IApiResponse } from "../../models/IAPIResponse";
import { IStudentTermDetail } from "../../models/student/studentTerm";
import APIService from "../../helper/api-service";
import { student } from "../../constants/apiUrl";

export default new (class studentTermDetailService {
  public getTermDetail = async (): Promise<
    IApiResponse<IStudentTermDetail>
  > => {
    try {
      const response = await APIService.get(student.STUDENT_TERM);
      return response.data as IApiResponse<IStudentTermDetail>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStudentTermDetail>;
      } else {
        throw error;
      }
    }
  };
})();
